import axios from 'axios';

export default {
  getAllForms: () => axios.get('/forms'),
  getFormFields: id => axios.get(`/forms/${id}/fields`),
  getSchema: id => axios.get(`/forms/${id}/schema`),
  getForm: ({ id, service, formId, value }) =>
    axios.get(`/${service}/${id}/${formId}/schema${value ? '/value' : ''}`),
};
